import React from 'react';
import { Box, Typography } from '@mui/material';
import { profileInfoItemStyles } from './ProfileInfoItem.styles';

const ProfileInfoItem = ({ icon, label, value, color = 'primary.main' }) => {
  return (
    <Box 
      sx={{
        ...profileInfoItemStyles.container,
        ...profileInfoItemStyles.getHoverBorderColor(color),
      }}
    >
      <Box
        sx={{
          ...profileInfoItemStyles.iconContainer,
          color: color,
        }}
      >
        {icon}
      </Box>
      <Box sx={profileInfoItemStyles.content}>
        <Typography variant="caption" sx={profileInfoItemStyles.label}>
          {label}
        </Typography>
        <Typography variant="body1" sx={profileInfoItemStyles.value}>
          {value || (
            <Box component="span" sx={profileInfoItemStyles.emptyValue}>
              Belirtilmemiş
            </Box>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProfileInfoItem; 